import {
  SET_COMPANY_ID,
  SET_IS_ADMIN,
  SET_MOBILE_VIEW,
  GET_COMPANY_INFO_REQUEST,
  UPDATE_COMPANY_INFO_REQUEST,
  CLEAR_MESSAGE,
  GET_BANNER_DATA_REQUEST,
  SET_NOTICE_HEIGHT,
  SET_ENLIGHTEN_MANAGER_TOKEN,
  GET_SFDC_REQUEST,
  UPDATE_ACCOUNT_MANAGER_REQUEST,
  GET_AB_FEATURE_REQUEST,
  SET_SHOW_PAGE,
  GET_USER_DETAILS,
  GET_IMAGE_BANNER_DATA_REQUEST,
  GET_APPLICATION_NOTIFICATIONS_REQUEST,
  READ_APPLICATION_NOTIFICATIONS_REQUEST,
  MARK_NOTIFICATION_AS_SEEN_REQUEST,
  SET_FROM_LEFT_TAB,
  GET_APPLICATION_REQUEST,
  DELETE_READ_NOTIFICATION_REQUEST,
  GET_SOLARGRAF_ACCESS,
  SET_SOLARGRAF_ACCESS_GRANT,
  GET_SOLARGRAF_SESSION,
  VERIFY_SOLARGRAF_SESSION,
  VERIFY_SOLARGRAF_EMAIL,
  GET_PROJECT_DETAILS_REQUEST,
  GET_SITE_DETAILS_REQUEST,
  GET_SOLARGRAF_POPUP_DETAILS_REQUEST,
  CAN_APPLY_DRS_FOR_CC_REQUEST,
  CREATE_DRS_APPLICATION_REQUEST,
  GET_ENLIGHTEN_VERSION_FOOTER,
  SET_COUNTRY
} from './constants';

export function setCompanyId(companyId) {
  companyId = parseInt(companyId);
  return { type: SET_COMPANY_ID, companyId };
}

export function setIsAdmin(isAdmin) {
  return { type: SET_IS_ADMIN, isAdmin };
}

export function setMobileView(isMobileView) {
  return { type: SET_MOBILE_VIEW, isMobileView };
}

export function setNoticeHeight(noticeHeight) {
  return { type: SET_NOTICE_HEIGHT, noticeHeight };
}

export function getCompanyInfo(companyId) {
  return { type: GET_COMPANY_INFO_REQUEST, companyId };
}

export function updateCompanyInfo(payload) {
  return { type: UPDATE_COMPANY_INFO_REQUEST, payload };
}

export function clearMesage() {
  return { type: CLEAR_MESSAGE };
}

export function getBannerData(payload = {}) {
  return { type: GET_BANNER_DATA_REQUEST, payload };
}

export function setEnlightenManagerToken(enlightenManagerToken) {
  return { type: SET_ENLIGHTEN_MANAGER_TOKEN, enlightenManagerToken };
}

export function getSFDCStats(payload) {
  return { type: GET_SFDC_REQUEST, payload };
}

export function updateAccountMangerInfo(payload) {
  return { type: UPDATE_ACCOUNT_MANAGER_REQUEST, payload };
}

export function getABFeatureList(payload) {
  return { type: GET_AB_FEATURE_REQUEST, payload };
}

export function setShowHidePage(showPage) {
  return { type: SET_SHOW_PAGE, showPage };
}

export function getUserDetails() {
  return { type: GET_USER_DETAILS };
}

export function getImageBannerData(payload = {}) {
  return { type: GET_IMAGE_BANNER_DATA_REQUEST, payload };
}

export function getApplicationNotifications(payload) {
  return { type: GET_APPLICATION_NOTIFICATIONS_REQUEST, payload };
}

export function readApplicationNotification(payload) {
  return { type: READ_APPLICATION_NOTIFICATIONS_REQUEST, payload };
}

export function markNotificationSeen(payload) {
  return { type: MARK_NOTIFICATION_AS_SEEN_REQUEST, payload };
}

export function setFromLeftPanel(fromLeftPanel) {
  return { type: SET_FROM_LEFT_TAB, fromLeftPanel };
}

export function getApplicationBySite(payload) {
  return { type: GET_APPLICATION_REQUEST, payload };
}

export function deleteReadNotification(payload) {
  return { type: DELETE_READ_NOTIFICATION_REQUEST, payload };
}

export function requestSolargrafAccess(payload) {
  return { type: GET_SOLARGRAF_ACCESS, payload };
}

export function grantSolargrafAccess(payload) {
  return { type: SET_SOLARGRAF_ACCESS_GRANT, payload };
}

export function getSolargrafSession(payload) {
  return { type: GET_SOLARGRAF_SESSION, payload };
}

export function verifySolargrafSession(payload) {
  return { type: VERIFY_SOLARGRAF_SESSION, payload };
}

export function verifySolargrafEmail(payload) {
  return { type: VERIFY_SOLARGRAF_EMAIL, payload };
}

export function getProjectDetails(payload) {
  return { type: GET_PROJECT_DETAILS_REQUEST, payload };
}

export function getSiteDetails(payload) {
  return { type: GET_SITE_DETAILS_REQUEST, payload };
}

export function setSolargrafPopupDetails(payload) {
  return { type: GET_SOLARGRAF_POPUP_DETAILS_REQUEST, payload };
}

// for drs left panel integration
export function canApplyDRSForCC(payload) {
  return { type: CAN_APPLY_DRS_FOR_CC_REQUEST, payload };
}
export function createDrsApplication(payload) {
  return { type: CREATE_DRS_APPLICATION_REQUEST, payload };
}
//ends

export function getEnlightenVersionFooter() {
  return { type: GET_ENLIGHTEN_VERSION_FOOTER };
}